import { Pipe, PipeTransform } from '@angular/core';
import { DaterangeService } from '../services/daterange.service';

@Pipe({
  name: 'sortAndLimit'
})
export class SortAndLimitPipe implements PipeTransform {

  constructor(private daterangeService: DaterangeService) { }

  transform(
    array: any[],
    excludeDevice: string = 'num',
    limit?: number,
    type?: string,
    includeMachineData: boolean = true,
    includeServiceData: boolean = true,
  ): any[] {
    if (!Array.isArray(array)) return [];

    const rangeKey =
      type === 'device'
        ? this.daterangeService.$selectedRangeFunctionLocation.value
        : this.daterangeService.$selectedRangeFunctionLocationSite.value;

    const score = (item: any): number => {
      const system = item?.system_health?.[rangeKey] ?? {};
      const service = item?.service_history?.[rangeKey] ?? {};
      const machineScore = includeMachineData
        ? (Number(system.autochecks) || 0) +
          (Number(system.maintenance) || 0) +
          (Number(system.proactive_alerts) || 0)
        : 0;
      const serviceScore = includeServiceData
        ? (Number(service.notifications_open) || 0)
        : 0;

      return machineScore + serviceScore;
    };

    const sorted = array
      .filter(f => f["serial_number"] !== excludeDevice)
      // Descending: highest score first
      .sort((a, b) => score(b) - score(a));

    if (limit != null) {
      return sorted.slice(0, limit); // limit provided → slice
    }

    return sorted; // no limit → return all sorted
  }
}